import React, { useContext } from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { GlobalContext } from "../../contexts/GlobalContext";
import UserAvatar from "../common/UserAvatar";

const ACCOUNT_PROFILE_PATH = "/profile?view=account";

const Footer = styled.div`
  background-color: ${(props) => props.theme.sidebar.footer.background} !important;
  padding: ${(props) => props.theme.spacing(2.75)} ${(props) => props.theme.spacing(4)};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
  position: relative;
  z-index: 1;
`;

const FooterText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SidebarFooter = ({ ...rest }) => {
  const { globalData } = useContext(GlobalContext);
  const displayName = globalData?.displayName || globalData?.userName || globalData?.email || "Account";
  const hasProfilePhoto = Boolean(globalData?.profilePhotoFileId);

  return (
    <Footer {...rest}>
      <Box
        component={Link}
        to={ACCOUNT_PROFILE_PATH}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          textDecoration: "none",
          color: "inherit",
          borderRadius: 1,
          py: 0.5,
          mx: -0.5,
          px: 0.5,
          cursor: "pointer",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
          },
        }}
        aria-label="Go to account information"
      >
        <UserAvatar
          profilePhotoFileId={hasProfilePhoto ? globalData.profilePhotoFileId : null}
          displayName={displayName}
          size={48}
          sx={
            hasProfilePhoto
              ? { fontSize: "1.1rem" }
              : {
                  bgcolor: "primary.main",
                  color: "primary.contrastText",
                  fontWeight: 600,
                  fontSize: "1.1rem",
                }
          }
        />
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <FooterText variant="body2">{displayName}</FooterText>
        </Box>
      </Box>
    </Footer>
  );
};

export default SidebarFooter;
export { ACCOUNT_PROFILE_PATH };
